import {
  IAccessRightsNumbers,
  IHiikoEnvironmentAdministrationView,
  ISimpleUser,
} from 'app/containers/User/slice/types';

/* --- STATE --- */
export interface AuthorizationState {
  user: ISimpleUser | null;
  envPermissions: {
    initLoaded: boolean;
    loading: boolean;
    permissionsArr: IAccessRightsNumbers;
  };
  companyPermissions: {
    initLoaded: boolean;
    loading: boolean;
    permissionsArr: IAccessRightsNumbers | null;
  };
  initLoaded: boolean;
  registerLoading: boolean;

  permissionsByCompany: IPermissionsByCompany;
}

export interface IPermissionsByCompany {
  analytics: number[];
  recommendation: number[];
}

export interface Environment {
  id: number;
  name: string;
}

export interface IUser {
  id: number;
  lastName: string;
  name: string;
  phoneNr: string;
  username?: string;
  email: string;
  environments?: Environment[];
  companyCount?: number;
}

export interface ILoginFormValues {
  email: string;
  password: string;
  rememberMe: boolean;
}

export interface IResetPasswordFormValues {
  email: string;
}

export interface ILoginOptions {
  redirectUri?: string;
  responseType?: string;
  responseMode?: 'query' | 'fragment';
  scope: string;
  connection: string;
  username: string;
  password: string;
}

export interface IRegisterFormValues {
  email: string;
  name: string;
  lastName: string;
  phoneNr: string;
  password: string;
  passwordRepeat: string;
  hiikoPrivacyPolicy: boolean;
  gudvilaPrivacyPolicy: boolean;
}

export enum loginFormEnum {
  email = 'email',
  password = 'password',
  rememberMe = 'rememberMe',
}
export enum resetPasswordEnum {
  email = 'email',
}

export enum registerFormEnum {
  email = 'email',
  name = 'name',
  lastName = 'lastName',
  phoneNr = 'phoneNr',
  password = 'password',
  passwordRepeat = 'passwordRepeat',
  hiikoPrivacyPolicy = 'hiikoPrivacyPolicy',
  gudvilaPrivacyPolicy = 'gudvilaPrivacyPolicy',
}

export interface IRegisterUser {
  email: string;
  name: string;
  lastName: string;
  phoneNr: string;
  password: string;
}

export interface IUserEnvPermissionsResponse
  extends IHiikoEnvironmentAdministrationView {
  [key: string]: unknown;
}

export interface IGetUserCompanyPermissionsPayload {
  envId: number;
  companyId: number;
}
